import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
  selector: "app-edit-coloums",
  templateUrl: "./edit-coloums.component.html",
  styleUrls: ["./edit-coloums.component.scss"],
})
export class EditColoumsComponent implements OnInit {
  constructor(
    public dialog: MatDialogRef<EditColoumsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      columnsFromComponents: string[];
      previoslySelectedColumns: string[];
    }
  ) {}
  selectAllFlag: boolean;
  columnsNameAll: string[] = this.data.columnsFromComponents;
  columnsData = [];
  selectedColoums: string[] = this.data.previoslySelectedColumns;
  res: any[] = [];
  ngOnInit(): void {
    this.selectAllFlag =
      this.selectedColoums.length == this.columnsNameAll.length;
    this.columnsData = this.columnsNameAll.map((el) => {
      if (this.data.previoslySelectedColumns.includes(el)) {
        return {
          name: el,
          checked: true,
        };
      } else {
        return {
          name: el,
          checked: false,
        };
      }
    });
  }

  setAll($event, propName, selectAll) {
    if (selectAll) {
      if ($event) {
        this.selectedColoums = [...this.columnsNameAll];
        this.columnsData = this.selectedColoums.map((el) => {
          return { name: el, checked: true };
        });
      } else {
        this.selectedColoums = [];
        this.columnsData = this.columnsNameAll.map((el) => {
          return { name: el, checked: false };
        });
      }
      return;
    }
    this.selectAllFlag = false;
    if ($event) {
      if (!this.selectedColoums.includes(propName)) {
        this.selectedColoums.push(propName);
      }
    } else {
      if (this.selectedColoums.includes(propName)) {
        this.selectedColoums = this.selectedColoums.filter(
          (name) => !(name == propName)
        );
      }
    }
    this.selectAllFlag =
      this.selectedColoums.length === this.columnsNameAll.length;
  }

  onClose() {
    this.dialog.close({ status: false, data: null });
  }

  onSubmit() {
    this.res = this.columnsData.filter((el) =>
      this.selectedColoums.includes(el.name)
    );
    this.res = this.res.map((el) => {
      return { ...el, checked: true };
    });
    this.dialog.close({ status: true, data: this.res });
  }
}
